import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=logged out, object=logged in

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
      return r.data;
    } catch {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("ss_token")) refresh();
    else setUser(false);
  }, [refresh]);

  const login = (token, u) => {
    localStorage.setItem("ss_token", token);
    setUser(u);
  };

  const logout = () => {
    localStorage.removeItem("ss_token");
    sessionStorage.removeItem("parent_token");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, logout, refresh }}>{children}</AuthContext.Provider>;
}
